import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CurrentPageService {
  private currentPageNodeIdSource = new BehaviorSubject<number>(0); // Initialize with 0
  currentPageNodeId$ = this.currentPageNodeIdSource.asObservable();

  // Method to update currentPageNodeId
  setCurrentPageNodeId(id: number) {
    this.currentPageNodeIdSource.next(id);
  }

  // Method to get the currentPageNodeId value (not as an observable)
  getCurrentPageNodeId(): number {
    return this.currentPageNodeIdSource.getValue();
  }

  private pageManagesTitleSubject = new BehaviorSubject<boolean>(false);
  pageManagesTitle$ = this.pageManagesTitleSubject.asObservable();

  setPageManagesTitle(value: boolean): void {
    this.pageManagesTitleSubject.next(value);
  }

  get pageManagesTitle(): boolean {
    return this.pageManagesTitleSubject.value;
  }
}